import api from "../../services/api";
import type {
  FormatTeamsResponse,
  FormatTeam,
  CreateFormatTeamsRequest,
  CreateFormatTeamsResponse,
  UpdateFormatTeamRequest,
} from "./types";

export const formatTeamsApi = {
  /**
   * Get all teams associated with a specific tournament format block
   */
  getFormatTeams: async (formatId: string): Promise<FormatTeamsResponse> => {
    return api.get(`/format-teams/format/${formatId}`);
  },

  /**
   * Bulk create format teams - adds multiple teams to a tournament format block
   */
  createFormatTeams: async (
    data: CreateFormatTeamsRequest
  ): Promise<CreateFormatTeamsResponse> => {
    return api.post(`/format-teams`, data);
  },

  /**
   * Update a format team's properties (group, seed, finalRank, qualifiedToNextStage, status).
   * Uses format team ID (from format-teams list), not team ID.
   */
  updateFormatTeam: async (
    formatTeamId: string,
    data: UpdateFormatTeamRequest
  ): Promise<FormatTeam> => {
    return api.patch(`/format-teams/${formatTeamId}`, data);
  },

  /**
   * Remove a team from a tournament format block by format team ID
   */
  deleteFormatTeam: async (formatTeamId: string): Promise<void> => {
    return api.delete(`/format-teams/${formatTeamId}`);
  },
};

